import React from 'react';
import SectionTitle from '../Common/SectionTitle';

const PricingPlan = ({ title, price, popular, description, features }) => {
  return (
    <div className="col-lg-4" data-aos="zoom-in" data-aos-delay={popular ? 200 : (price === 0 ? 100 : 300)}>
      <div className={`pricing-item ${popular ? 'featured' : ''}`}>
        {popular && <p className="popular">Popular</p>}
        <h3>{title}</h3>
        <p className="description">{description}</p>
        {price !== null && <h4><sup>$</sup>{price}<span> / month</span></h4>}
        <a href="#" className="cta-btn">Get Demo</a>
        <ul>
          {features.map((feature, index) => (
            <li key={index} className={feature.available ? '' : 'na'}>
              <i className={`bi bi-${feature.available ? 'check' : 'x'}`}></i> <span>{feature.text}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

const Pricing = () => {
  const pricingPlans = [
    {
      title: 'Tally on Cloud',
      price: null,
      description: 'Guaranteed speed with 24/7 support that gives an edge over competition',
      popular: false,
      features: [
        { text: 'Manager Server', available: true },
        { text: 'Auto Backup', available: true },
        { text: 'Highly Secure', available: true },
        { text: 'Unlimited Companies', available: true },
        { text: 'Scalable Any Time', available: true },
        { text: '24X7 Days Support', available: true },
        { text: 'Fully Secured', available: true }
      ]
    },
    {
      title: 'VPS SERVER',
      price: null,
      description: 'Extremely Powerful NVMe Based NXTGEN VPS Servers.',
      popular: true,
      features: [
        { text: '2v CPU', available: true },
        { text: '4GB RAM', available: true },
        { text: '30GB Storage', available: true },
        { text: '100% Uptime', available: true },
        { text: 'Scalable Any Time', available: true },
        { text: '24X7 Days Support', available: true },
        { text: 'Fully Secured', available: true }
      ]
    },
    {
      title: 'DEDICATED SERVER',
      price: null,
      description: 'Extremely Powerful NVMe Based NXTGEN Dedicated Servers.',
      popular: false,
      features: [
        { text: '4v CPU', available: true },
        { text: '64GB RAM', available: true },
        { text: '500GB Storage', available: true },
        { text: '100% Uptime', available: true },
        { text: 'Scalable Any Time', available: true },
        { text: '24X7 Days Support', available: true },
        { text: 'Fully Secured', available: true }
      ]
    }
  ];

  return (
    <section id="pricing" className="pricing section">
      <SectionTitle 
        title="Pricing" 
        description1="Check Our" 
        description2="Pricing" 
      />

      <div className="container">
        <div className="row gy-4">
          {pricingPlans.map((plan, index) => (
            <PricingPlan 
              key={index}
              title={plan.title}
              price={plan.price}
              description={plan.description}
              popular={plan.popular}
              features={plan.features}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Pricing; 